module.exports = __webpack_public_path__ + "img/img_origfac_desp.8ff615d3.png";